import type { App, Directive, DirectiveBinding } from 'vue'
import { useI18n } from '@/hooks/web/useI18n'
import router from '@/router'
import { useStorage } from '@/hooks/web/useStorage'

const { getStorage } = useStorage()

const { t } = useI18n()

// 优化后的权限判断函数，支持单个权限和多个权限数组
export function hasPermission(permission: string | string[]): boolean {
  // 从本地存储读取btnList
  const btnList = getStorage('btnList')

  if (!btnList || !Array.isArray(btnList)) {
    return false
  }

  // 循环对象数组取出每一项中的name，组成新的权限数组
  const permissions = btnList.map((item) => item.name)

  // 支持单个权限字符串和多个权限字符串数组
  if (typeof permission === 'string') {
    // 单个权限判断
    return permissions.includes(permission)
  } else if (Array.isArray(permission)) {
    // 多个权限判断：必须全部都有才能返回true
    return permission.every((item) => permissions.includes(item))
  }

  return false
}
function hasPermi(el: Element, binding: DirectiveBinding) {
  const value = binding.value

  const flag = hasPermission(value)
  if (!flag) {
    el.parentNode?.removeChild(el)
  }
}
const mounted = (el: Element, binding: DirectiveBinding<any>) => {
  hasPermi(el, binding)
}

const permiDirective: Directive = {
  mounted
}

export const setupPermissionDirective = (app: App<Element>) => {
  app.directive('hasPermi', permiDirective)
}

export default permiDirective
